import React from "react";
import { Grid2 as Grid, LabelValue, pxToRem, Typography } from "@platform/style";
import { format, parseISO } from "date-fns";
import { WorkItemStatusChip } from "../WorkItemStatusChip";
import { WorkItem } from "../../models/WorkItem";
import { getIdentifier } from "../../utils/getIdentifier";

interface RenderDetailsProps {
  workItem: WorkItem;
  loanNumber: string;
  isInactiveWITab: boolean;
}

export const RenderDetails = ({ workItem, loanNumber, isInactiveWITab }: RenderDetailsProps) => {
  return (
    <>
      <Typography component="span" variant={"detailsBarText"}>
        <Grid
          container
          rowGap={1}
          paddingLeft={pxToRem(2)}
          direction={"column"}
          paddingTop={pxToRem(16)}
          paddingBottom={pxToRem(16)}
        >
          {!isInactiveWITab && (
            <Grid container direction={"row"} spacing={2}>
              <Grid sx={{ minWidth: pxToRem(180) }} role={"rowheader"} id={"wiStatus"}>
                <WorkItemStatusChip status={workItem.Status} />
              </Grid>
            </Grid>
          )}

          <LabelValue label={"ID"} value={getIdentifier(workItem.WorkItemIdentifier)} id={"wiId"} />
          <LabelValue label={"LoanNumber"} value={loanNumber.toString()} id={"wiLoanNumber"} />
          <LabelValue label={"Business Area"} value={workItem.BusinessArea} id={"wiBusinessArea"} />
          {!isInactiveWITab && (
            <LabelValue
              label={"Due Date"}
              value={format(parseISO(workItem.DueDate.toString()), "MM/dd/yyyy")}
              id={"wiDueDate"}
            />
          )}
          {isInactiveWITab && (
            <LabelValue
              label={"Completed Date"}
              value={format(parseISO(workItem.ClosedDatetime.toString()), "MM/dd/yyyy")}
              id={"wiCompletedDate"}
            />
          )}
          <LabelValue
            label={"Created Date"}
            value={format(parseISO(workItem.CreatedDatetime!.toString()), "MM/dd/yyyy")}
            id={"wiDateCreated"}
          />
          {workItem?.FollowUpDate && !isInactiveWITab ? (
            <LabelValue
              label={"Follow-Up Date"}
              value={format(parseISO(workItem.FollowUpDate.toString()), "MM/dd/yyyy")}
              id={"wiFollowUpDate"}
            />
          ) : null}
          <LabelValue label={"Assigned To"} value={workItem.AssignedTo} id={"wiAssignedTo"} />
          <LabelValue label={"Created By"} value={workItem.CreatedBy} id={"wiCreatedBy"} />

          <LabelValue label={"Description"} value={workItem.Description} id={"wiDescription"} />
        </Grid>
      </Typography>
    </>
  );
};
